export default __webpack_public_path__ + "static/media/banner-lp.304f0c53.png";